import styled from '@emotion/styled';
import { Ui } from '@silvertours/front-shared';

export const FormContainer = styled(Ui.Card)`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing['40']};
  padding: ${({ theme }) => theme.spacing['40']};
`;

export const Headline = styled.span`
  font-family: ${({ theme }) => theme.fontFamily.alternate};
  font-size: ${({ theme }) => theme.fontSize.md.size};
  font-weight: ${({ theme }) => theme.fontWeight.heading};
  color: ${({ theme }) => theme.color.brand};
`;

export const SearchButton = styled.button`
  position: relative;
  background-color: ${({ theme }) => theme.color.white};
  border-radius: ${({ theme }) => theme.borderRadius.md};
  border: 1px solid ${({ theme }) => theme.color.grey03};
  color: ${({ theme }) => theme.color.text};
  font-family: ${({ theme }) => theme.fontFamily.default};
  font-size: ${({ theme }) => theme.fontSize.sm.size};
  font-weight: ${({ theme }) => theme.fontWeight.body};
  padding: ${({ theme }) => theme.spacing['40']};
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing['30']};
  cursor: pointer;
`;

export const EmbeddedButton = styled.span`
  position: absolute;
  border-radius: 0 ${({ theme }) => theme.borderRadius.md}
    ${({ theme }) => theme.borderRadius.md} 0;
  height: 100%;
  background-color: ${({ theme }) => theme.color.brand};
  top: 0;
  right: 0;
  padding: ${({ theme }) => theme.spacing['40']};
  color: ${({ theme }) => theme.color.white};
  line-height: ${({ theme }) => theme.fontSize.sm.lineHeight};
`;
